export default __webpack_public_path__ + "static/media/create-message.a7b7e7bf.svg";